import { FC } from 'react'
import { Address, Information } from 'graphql/types'
import * as events from 'pages/regioes-atendidas/regiao/events'
import { TLocation } from 'pages/regioes-atendidas/regiao/types'
import HeroComponent from 'pages/regioes-atendidas/regiao/components/Hero'
import { getRegionImageUrl } from 'lib/region'

export type TProps = {
  address: Address
  condominium?: {
    name: string
    nameSlug: string
  }
  title?: string
  imageFilename?: Information['imageFilename']
  locationType: TLocation
}

const Hero: FC<TProps> = ({
  address,
  condominium,
  title,
  locationType,
  imageFilename,
}) => {
  const condominiumPath = condominium ? `/${condominium.nameSlug}` : ''
  const CTAUrl = `/imoveis/${address.stateSlug as string}/${
    address.citySlug as string
  }/${address.neighborhoodSlug || ''}${condominiumPath}`

  const breadcrumbOnClick = (label: string, url: string) =>
    events.breadcrumbEvent(label, url)

  const neighborhoodBreadcrumbItem =
    address.neighborhood && address.neighborhoodSlug
      ? [
          {
            label: address.neighborhood,
            to: `/regioes-atendidas/${address.stateSlug as string}/${
              address.citySlug as string
            }/${address.neighborhoodSlug}`,
            active: !condominium,
            onClick: breadcrumbOnClick,
          },
        ]
      : []

  const condominiumBreadcrumbItem = condominium
    ? [
        {
          label: condominium.name,
          to: `/regioes-atendidas/${address.stateSlug as string}/${
            address.citySlug as string
          }${address.neighborhoodSlug as string}${condominiumPath}`,
          active: true,
          onClick: breadcrumbOnClick,
        },
      ]
    : []

  const breadcrumbItems = [
    {
      label: 'Início',
      to: '/',
      onClick: breadcrumbOnClick,
    },
    {
      label: 'Regiões Atendidas',
      to: '/regioes-atendidas',
      onClick: breadcrumbOnClick,
    },
    {
      label: address.city as string,
      to: `/regioes-atendidas/${address.stateSlug as string}/${
        address.citySlug as string
      }`,
      onClick: breadcrumbOnClick,
      active: !address.neighborhood && !address.neighborhoodSlug,
    },
    ...neighborhoodBreadcrumbItem,
    ...condominiumBreadcrumbItem,
  ]

  return (
    <HeroComponent
      breadcrumbList={breadcrumbItems}
      title={condominium?.name || address.neighborhood || address.city}
      text={title}
      button={{
        label: 'Ver imóveis aqui',
        href: CTAUrl,
        onClick: () => events.heroCtaButtonClickEvent(locationType, CTAUrl),
      }}
      image={{
        src: getRegionImageUrl(imageFilename),
        alt: address.neighborhood || address.city || '',
      }}
    />
  )
}

export default Hero
